import { render, staticRenderFns } from "./AboutStagesBlock.vue?vue&type=template&id=550e047a"
import script from "./AboutStagesBlock.vue?vue&type=script&lang=js"
export * from "./AboutStagesBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutStagesBlock.vue?vue&type=style&index=0&id=550e047a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports